
<app-scotty-card [title]="'Personnel' | translate" hideDivisor="true" [actions]="getActions()">

  <ng-container *ngIf="!isLoading; else loading">
    <app-list-view-element *ngFor="let person of personnelToShow"
                           [icon]="person['icon']"
                           [title]="person['name']"
                           [subtitle]="person['email']"
                           [chips]="person['fieldServices']"
                           [onlineStatus]="person['online']"
                           (click)="router.navigate(['personnel', person['uid']])"
    ></app-list-view-element>
    <p *ngIf="personnelToShow.length == 0" class="info">{{ 'No personnel found' | translate }}</p>
  </ng-container>

  <mat-paginator
    [hidePageSize]="true"
    [pageSize]="paginator.pageSize"
    [pageIndex]="paginator.currentPage"
    [length]="paginator.totalElements"
    (page)="paginator.pageChanged($event)"
    showFirstLastButtons>
  </mat-paginator>

  <!--<app-table [columns]="getTableColumns()" [rows]="getTableRows()"></app-table>-->

</app-scotty-card>

<ng-template #loading>
  <app-scotty-spinner></app-scotty-spinner>
</ng-template>
